module.exports = __webpack_public_path__ + "img/DK58943010.e894848f.png";